import {
  Button, Card, Flex, Modal, Space, Typography
} from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { RightOutlined, LeftOutlined, CheckCircleFilled } from "@ant-design/icons";
import type { Swiper as SwiperClass } from "swiper/types";
import { Navigation, Mousewheel } from "swiper/modules";
import usePatientAppointments from "./usePatientAppointments";
import { AppointmentType } from "../../types/user";
import Appointment from "../Appointment";
import classes from "./patientAppointments.module.css";

import "swiper/css";
import Scheduler from "../Scheduler";

const { Title, Text } = Typography;

const PatientAppointments = () => {
  const {
    appointments,
    swiperRef,
    isModalOpen,
    selectedDate,
    handleOnClick,
    onCancel,
    onSubmit,
    isSubmitButtonLoading,
    arrowPrevRef,
    arrowNextRef
  } = usePatientAppointments();

  return (
    <Flex vertical>
      {appointments && appointments.length > 0
        ? (
          <div style={{ marginBottom: 16 }}>
            <Flex gap={16} style={{ marginBottom: 16 }}>
              <Title level={4} style={{ marginBottom: 0 }}>I tuoi appuntamenti</Title>
              {appointments.length ? (
                <Space size={8}>
                  <Button
                    ref={arrowPrevRef}
                    type="text"
                    size="small"
                    icon={<LeftOutlined/>}
                    // onClick={handlePrev}
                  />
                  <Button
                    ref={arrowNextRef}
                    type="text"
                    size="small"
                    icon={<RightOutlined/>}
                    // onClick={handleNext}
                  />
                </Space>
              ) : null}
            </Flex>

            <div className={classes.slider}>
              <Swiper
                modules={[Navigation, Mousewheel]}
                ref={swiperRef}
                spaceBetween={12}
                slidesPerView={1}
                freeMode
                watchOverflow
                navigation={{
                  prevEl: arrowPrevRef.current,
                  nextEl: arrowNextRef.current
                }}
                onBeforeInit={(swiper: SwiperClass) => {
                  swiper.params.navigation.prevEl = arrowPrevRef.current;
                  swiper.params.navigation.nextEl = arrowNextRef.current;
                }}
                onUpdate={(swiper: SwiperClass) => {
                  swiper.navigation.init();
                  swiper.navigation.update();
                }}
                breakpoints={{
                  "600": {
                    slidesPerView: "auto"
                  }
                }}
                mousewheel={{
                  forceToAxis: true
                }}
                style={{ width: "100%" }}
              >
                {appointments.map((appointmentItem: AppointmentType) => (
                  <SwiperSlide key={appointmentItem.id} className={classes.slide}>
                    <Appointment appointment={appointmentItem}/>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        )
        : null}
      <Title level={5} style={{ fontWeight: 400, marginBottom: 16, marginTop: 25 }}>
        Se non dovesse trovare la disponibilità oraria o giornaliera desiderata,
        La invitiamo a contattare direttamente il Suo psiconcologo.
        Può farlo comodamente scrivendo un messaggio nella sezione Messaggi qui
        sotto oppure inviando una mail a <a href="mailto:supporto@inbuonasalute.eu">supporto@inbuonasalute.eu</a>.
      </Title>
      <Card size="small">
        <Scheduler onTimeClick={handleOnClick}/>
      </Card>
      <Modal
        title={(
          <Space>
            <CheckCircleFilled style={{
              fontSize: 22, color: "#52c41a"
            }}
            />
            <Text style={{ fontSize: 18 }}>Conferma prenotazione</Text>
          </Space>
        )}
        open={isModalOpen}
        onOk={onSubmit}
        centered
        width={380}
        onCancel={onCancel}
        okText="Conferma"
        cancelText="Torna indietro"
        okButtonProps={{ loading: isSubmitButtonLoading, disabled: isSubmitButtonLoading }}
      >
        Sei sicuro di confermare l&apos;appuntamento in data:&nbsp;
        <b style={{ color: "#356ab3" }}>{selectedDate}</b>
      </Modal>
    </Flex>
  );
};

export default PatientAppointments;
